// extracted by css-extract-rspack-plugin
export default {"videoContainer":"_c123b74d"};